{
  "processing": "正在處理驗證...",
  "loadingIframe": "正在載入身分驗證...",
  "issueTitle": "身分驗證問題",
  "notConfigured": "此倉庫的身分驗證設定不正確。",
  "notSuccessful": "身分驗證未成功，請再試一次或聯絡倉庫。",
  "couldNotCompleteProceed": "無法完成身分驗證，但您仍可繼續報到。",
  "processFailed": "處理身分驗證失敗，請再試一次。",
  "processingFailedProceed": "身分驗證處理失敗，但您仍可繼續報到。",
  "genericError": "身分驗證期間發生錯誤，請再試一次。",
  "issueProceed": "身分驗證發生問題，但您仍可繼續報到。",
  "requiredTryAgain": "必須完成身分驗證才能報到，請再試一次。",
  "checkInFailedTitle": "無法報到",
  "checkInFailedMessage": "無法驗證您的身分證件"
}
